import { render } from "./ArchivedRelatedDocumentsSection.vue?vue&type=template&id=110e48ac&scoped=true&ts=true&lang=pug"
import script from "./ArchivedRelatedDocumentsSection.vue?vue&type=script&lang=ts"
export * from "./ArchivedRelatedDocumentsSection.vue?vue&type=script&lang=ts"

import "./ArchivedRelatedDocumentsSection.vue?vue&type=style&index=0&id=110e48ac&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110e48ac"]])

export default __exports__